const urlEncodedContentType = 'application/x-www-form-urlencoded';
const jsonContentType = 'application/json';

export class AddressVerificationPostGridApiService {
  constructor() {
    this.getAutoCompleteAddresses = this.getAutoCompleteAddresses.bind(this);
    this.getAddressDetails = this.getAddressDetails.bind(this);
  }

  async fetchData(url, method, body, contentType) {
    const response = await fetch(url, {
      method: method,
      headers: {
        'Content-Type': contentType,
        'x-api-key': window.env.postGridApiKey,
      },
      body: body,
    })
    if (response.status !== 200) {
      throw new Error('Error in calling the API.');
    }
    const data = await response.json();
    return { data: data };
  }

  async getAddressData(requestUrl) {
    let response = await this.fetchData(requestUrl, 'POST', null, urlEncodedContentType);
    let addresses = response.data.data.map((n, index) => {
      return {
        place_id: index,
        description: `${n.preview.address}, ${n.preview.city}, ${n.preview.prov}`,
      };
    })
    return addresses;
  }

  async getAutoCompleteAddresses(searchTerm, city, province) {
    if ('' === searchTerm) return [];
    let baseRequestUrl = `https://api.postgrid.com/v1/addver/completions`;
    let requestUrl = baseRequestUrl;

    const bodyData = {
      partialStreet: (searchTerm + " " + city).trim(),
      stateFilter: province,
      countryFilter: 'CA',
    }

    let response = await this.fetchData(requestUrl, "Post", JSON.stringify(bodyData), jsonContentType);
    const addresses = response.data.data;
    const result = addresses.map((item, index) => ({
      place_id: index,
      description: `${item.address.address}, ${item.address.city}, ${item.address.prov}, ${item.address.pc}`,
      fullAddress: { ...item.address }
    }));

    return result;
  }

  async getAddressDetails(place_id, partialStreet, city, province) {
    let requestUrl = `https://api.postgrid.com/v1/addver/completions?index=${place_id}`;
    let body = JSON.stringify({ 'partialStreet': partialStreet, 'countryFilter': 'CA', stateFilter: province, cityFilter: city });
    let response = await this.fetchData(requestUrl, 'POST', body, jsonContentType);
    if (response.data.data.length === 0) {
      body = JSON.stringify({ 'partialStreet': partialStreet, 'countryFilter': 'CA' });
      response = await this.fetchData(requestUrl, 'POST', body, jsonContentType);
    }
    return {
      'address': response.data.data.address.address,
      'city': response.data.data.address.city,
      'postal_code': response.data.data.address.pc,
      'province': response.data.data.address.prov,
    }
  }
}